<div class="map" *ngIf="link">
  <iframe width="100%" style="border:0;" height="100%" [src]="link"></iframe>
</div>
